import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

const application = Application.start();

// Make Stimulus application available globally for cross-controller communication
window.Stimulus = application;

// Auto-load all controllers in this directory to avoid double registration
const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
